module.exports = __webpack_public_path__ + "static/ramenshoyu-368c8d37700667cc1fb6d4b738679cc4.jpg";